import { Button } from "antd";
import type { ReactNode } from "react";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import MineIcon from "@/assets/icons/MineIcon.svg?react";
import SharedPanelIcon from "@/assets/icons/SharedIcon2.svg?react";
import type { SortDirection } from "@/components/Insights/insights.constants";

interface DataPanelProps {
  title: "MINE" | "SHARED";
  count: number;
  sortDirection: SortDirection;
  onSortChange: (direction: SortDirection) => void;
  children: ReactNode;
  emptyMessage?: string;
}

export default function DataPanel({
  title,
  count,
  sortDirection,
  onSortChange,
  children,
  emptyMessage,
}: DataPanelProps) {
  const toggleSortDirection = () => {
    onSortChange(sortDirection === "desc" ? "asc" : "desc");
  };

  const defaultEmptyMessage =
    title === "MINE"
      ? "No items have been created"
      : "No items have been shared";

  return (
    <div
      className="flex flex-col border rounded-md overflow-hidden pb-3"
      style={{ backgroundColor: "#0000000a" }}
    >
      <div className="flex justify-between items-center px-4 py-3 border-b">
        <div className="flex items-center gap-2">
          {title === "MINE" ? <MineIcon /> : <SharedPanelIcon />}
          <h3 className="text-sm font-semibold text-[#556C75]">
            {title} ({count})
          </h3>
        </div>
        <Button
          type="text"
          size="small"
          onClick={toggleSortDirection}
          className="hover:bg-gray-100 text-sm"
          title={sortDirection === "desc" ? "Newest first" : "Oldest first"}
        >
          {sortDirection === "desc" ? "Newest" : "Oldest"}
          {sortDirection === "desc" ? (
            <ArrowDownOutlined className="ml-1" />
          ) : (
            <ArrowUpOutlined className="ml-1" />
          )}
        </Button>
      </div>
      <div className="overflow-y-auto px-3">
        {count === 0 ? (
          <div className="flex items-center justify-center min-h-64 p-4">
            <p className="text-[#00000073] text-sm text-center">
              {emptyMessage || defaultEmptyMessage}
            </p>
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
}
